const UTMIFY_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js';

/**
 * Official UTMify UTM tracking script.
 * Equivalent to:
 * <script src="https://cdn.utmify.com.br/scripts/utms/latest.js"
 *   data-utmify-prevent-xcod-sck data-utmify-prevent-subids async defer></script>
 */
export function loadUtmify(): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return;

  const script = document.createElement('script');
  script.src = UTMIFY_SRC;
  script.setAttribute('data-utmify-prevent-xcod-sck', '');
  script.setAttribute('data-utmify-prevent-subids', '');
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
